var _filter, _marker, _rect, _text, _text2, _line, _g, _g2, _g3, _line2, _line3, _g4, _path, _path2, _g5, _g6, _g7, _path3, _path4, _g8, _g9, _path5, _path6, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg08Signaling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 550",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "signalingGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ec4899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#db2777"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "browserGradA",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563eb"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "browserGradB",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowSig",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.25
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowPink",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#f472b6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 550,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    Signaling Process\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 65,
    textAnchor: "middle",
    fill: "#f472b6",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    Exchanging connection information before P2P\n  ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 100,
    x2: 450,
    y2: 470,
    stroke: "#334155",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 120)",
    filter: "url(#shadowSig)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -30,
    width: 140,
    height: 60,
    rx: 12,
    fill: "url(#signalingGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "Signaling Server"), /*#__PURE__*/React.createElement("text", {
    y: 22,
    textAnchor: "middle",
    fill: "#fbcfe8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "WebSocket / Socket.IO"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 120)",
    filter: "url(#shadowSig)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -40,
    width: 160,
    height: 80,
    rx: 14,
    fill: "url(#browserGradA)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -28,
    width: 130,
    height: 50,
    rx: 8,
    fill: "#1e3a8a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: "bold"
  }, "Browser A"), /*#__PURE__*/React.createElement("text", {
    y: 25,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Caller"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(750, 120)",
    filter: "url(#shadowSig)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -40,
    width: 160,
    height: 80,
    rx: 14,
    fill: "url(#browserGradB)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -28,
    width: 130,
    height: 50,
    rx: 8,
    fill: "#064e3b",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: "bold"
  }, "Browser B"), /*#__PURE__*/React.createElement("text", {
    y: 25,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Callee"))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 180,
    x2: 150,
    y2: 470,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "4,4",
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 180,
    x2: 750,
    y2: 470,
    stroke: "#10b981",
    strokeWidth: 2,
    strokeDasharray: "4,4",
    opacity: 0.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 210)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -18,
    width: 130,
    height: 36,
    rx: 8,
    fill: "#1e40af"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#bfdbfe",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "\u2460 createOffer()"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 230 220 L 380 220",
    stroke: "#f472b6",
    strokeWidth: 2,
    markerEnd: "url(#arrowPink)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,200;150,200",
    dur: "0.5s",
    fill: "freeze"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 220 L 670 220",
    stroke: "#f472b6",
    strokeWidth: 2,
    markerEnd: "url(#arrowPink)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,200;150,200",
    dur: "0.5s",
    fill: "freeze",
    begin: "0.3s"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#be185d"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600
  }, "SDP Offer"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(750, 270)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    y: -18,
    width: 150,
    height: 36,
    rx: 8,
    fill: "#065f46"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#a7f3d0",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "\u2461 setRemoteDescription()"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(750, 320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -18,
    width: 130,
    height: 36,
    rx: 8,
    fill: "#065f46"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#a7f3d0",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "\u2462 createAnswer()"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 670 360 L 520 360",
    stroke: "#f472b6",
    strokeWidth: 2,
    markerEnd: "url(#arrowPink)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,200;150,200",
    dur: "0.5s",
    fill: "freeze",
    begin: "0.6s"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 380 360 L 230 360",
    stroke: "#f472b6",
    strokeWidth: 2,
    markerEnd: "url(#arrowPink)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,200;150,200",
    dur: "0.5s",
    fill: "freeze",
    begin: "0.9s"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#be185d"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600
  }, "SDP Answer"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 400)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75,
    y: -18,
    width: 150,
    height: 36,
    rx: 8,
    fill: "#1e40af"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#bfdbfe",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "\u2463 setRemoteDescription()"))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 230 440 L 380 440 L 520 440 L 670 440",
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-18",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 670 455 L 520 455 L 380 455 L 230 455",
    stroke: "#22d3ee",
    strokeWidth: 2,
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-18",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 448)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -18,
    width: 110,
    height: 36,
    rx: 8,
    fill: "#1e293b",
    stroke: "#fbbf24",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fcd34d",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600
  }, "\u2464 ICE Candidates"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 495)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 45,
    rx: 8,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 18,
    fill: "#f472b6",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: "bold"
  }, "Signaling Server:"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 35,
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "\n      Used ONLY for initial handshake, not for media data\n    "))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(470, 495)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 45,
    rx: 8,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 18,
    fill: "#fbbf24",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: "bold"
  }, "SDP (Session Description Protocol):"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 35,
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "\n      Contains codecs, media types, network info\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08Signaling);
export default __webpack_public_path__ + "static/media/08-signaling.540f64bf7316661d84fe0fab531122ac.svg";
export { ForwardRef as ReactComponent };